import CheckIcon from "@mui/icons-material/Check";

export default function ConfirmationModal({
  open,
  onClose,
  brandColors,
}) {
  if (!open) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 60,
      }}
    >
      <div
        style={{
          backgroundColor: brandColors.surface,
          borderRadius: "8px",
          boxShadow: "0 10px 15px -3px rgba(0,0,0,0.1)",
          padding: "32px",
          maxWidth: "384px",
          textAlign: "center",
        }}
      >
        <div
          style={{
            margin: "0 auto",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "48px",
            width: "48px",
            borderRadius: "9999px",
            backgroundColor: "#dcfce7",
            marginBottom: "16px",
          }}
        >
          <CheckIcon style={{ fontSize: "32px", color: "#16a34a" }} />
        </div>
        <h3
          style={{
            fontSize: "18px",
            fontWeight: "bold",
            fontFamily: "inherit",
            marginBottom: "8px",
          }}
        >
          Pedido Enviado!
        </h3>
        <p
          style={{
            fontSize: "14px",
            color: brandColors.textMuted,
            marginTop: "8px",
          }}
        >
          Seu pedido foi enviado com sucesso.
        </p>
        <button
          onClick={onClose}
          style={{
            marginTop: "24px",
            width: "100%",
            backgroundColor: brandColors.primary,
            color: "white",
            fontWeight: "bold",
            padding: "8px",
            borderRadius: "8px",
            border: "none",
            cursor: "pointer",
            transition: "background-color 0.3s",
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = brandColors.primaryHover;
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = brandColors.primary;
          }}
        >
          Fechar
        </button>
      </div>
    </div>
  );
}

